(function () {
  const FALLBACK_MESSAGE = "Size details are currently being updated. Please contact us for sizing help.";

  const COLLECTION_TYPE_MAP = {
    "mens-3-piece-suits": "three_piece_suit",
    "mens-three-piece-suits": "three_piece_suit",
    "men-suit": "three_piece_suit",
    "men-tweed-suit": "three_piece_suit",
    "men-plaid-suits": "three_piece_suit",
    "men-stripe-suits": "three_piece_suit",
    "men-corduroy-suits": "three_piece_suit",
    "men-linen-suit-2": "three_piece_suit",
    "men-velvet-suit-1": "three_piece_suit",
    "\u7537\u58eb\u897f\u670d\u6a21\u5757": "three_piece_suit",
    "mens-2-piece-suits": "two_piece_suit",
    "mens-two-piece-suits": "two_piece_suit",
    "mens-blazers": "blazer",
    "men-suit-jacket": "blazer",
    "men-linen-jacket": "blazer",
    "men-tweed-jacket": "blazer",
    "men-corduroy-jacket": "blazer",
    "men-suede-jacket": "blazer",
    "men-velvet-jacket": "blazer",
    "\u7537\u58eb\u5916\u5957\u6a21\u5757": "blazer",
    "mens-vests": "vest",
    "men-suit-vest-1": "vest",
    "men-business-vests": "vest",
    "men-linen-vest": "vest",
    "men-tweed-vest": "vest",
    "tweed-vest": "vest",
    "tweed-vest-1": "vest",
    "men-corduroy-vest": "vest",
    "men-suede-vest": "vest",
    "\u7537\u58eb\u9a6c\u7532\u6a21\u5757": "vest",
    "mens-trousers": "pants",
    "mens-pants": "pants",
    "suit-pants": "pants",
    "men-linen-pants": "pants",
    "men-plaid-pants": "pants",
    "men-stripe-pants": "pants",
    "men-velvet-pants": "pants",
    "linen": "pants",
    "tweed": "pants",
    "corduroy-pants": "pants",
    "\u7537\u58eb\u88e4\u5b50\u6a21\u5757": "pants",
    "womens-3-piece-suits": "women_suit",
    "womens-2-piece-suits": "women_suit",
    "womens-suits": "women_suit",
    "women-suit": "women_suit",
    "women-classic-suit-2-piece": "women_suit",
    "women-corduroy-2-piece": "women_suit",
    "women-corduroy-suit": "women_suit",
    "women-linen-2-piece": "women_suit",
    "women-linen-suit": "women_suit",
    "women-tweed-suit": "women_suit",
    "women-velvet-2-piece": "women_suit",
    "women-velvet-suits": "women_suit",
    "women-wool-2-piece": "women_suit",
    "womens-vest-trouser-sets": "women_suit",
    "\u5973\u58eb\u5957\u88c5\u6a21\u5757": "women_suit",
    "womens-blazers": "women_blazer",
    "women-blazers": "women_blazer",
    "womens-pants": "women_pants",
    "women-pants": "women_pants",
    "womens-vests": "vest",
    "women-suit-vest": "vest",
    "women-linen-vest-1": "vest",
    "women-corduroy-vests": "vest",
    "women-tweed-vest": "vest",
    "wome-suede-vest": "vest",
    "\u5973\u58eb\u9a6c\u7532\u6a21\u5757": "vest",
  };

  let sizeChartDataPromise;

  function normalizeSize(size) {
    return String(size || "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "")
      .replace(/^XXL$/, "2XL")
      .replace(/^XXXL$/, "3XL");
  }

  function normalizeChartSize(size) {
    return normalizeSize(size)
      .replace(/×/g, "X")
      .replace(/-/g, "")
      .replace(/_/g, "");
  }

  function isCustomSize(size) {
    const normalizedSize = String(size || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[-_]/g, "");

    return normalizedSize === "customsize";
  }

  function normalizeHandle(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/_/g, "-");
  }

  function normalizeGender(value) {
    const gender = String(value || "").trim().toLowerCase();

    if (gender === "women" || gender === "woman" || gender === "female" || gender === "womens") {
      return "women";
    }

    if (gender === "men" || gender === "man" || gender === "male" || gender === "mens") {
      return "men";
    }

    return "";
  }

  function normalizeType(value) {
    return String(value || "").trim().toLowerCase().replace(/-/g, "_").replace(/\s+/g, "_");
  }

  function getConfig() {
    return window.productSizeChartConfig || {};
  }

  function escapeHTML(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function resolveGender(config, sizeChartType) {
    const metafieldGender = normalizeGender(config.gender);

    if (metafieldGender) {
      return metafieldGender;
    }

    if (String(sizeChartType || "").startsWith("women_")) {
      return "women";
    }

    const collections = Array.isArray(config.collections) ? config.collections.map(normalizeHandle) : [];

    if (collections.some((handle) => handle.startsWith("womens-"))) {
      return "women";
    }

    return "men";
  }

  function resolveSizeChartType(config) {
    const metafieldType = normalizeType(config.sizeChartType);

    if (metafieldType) {
      return metafieldType;
    }

    const collections = Array.isArray(config.collections) ? config.collections.map(normalizeHandle) : [];
    const matchedCollection = collections.find((handle) => COLLECTION_TYPE_MAP[handle]);

    return matchedCollection ? COLLECTION_TYPE_MAP[matchedCollection] : "";
  }

  function getDataUrl() {
    return window.productSizeChartDataUrl || "";
  }

  function loadSizeChartData() {
    if (!sizeChartDataPromise) {
      const dataUrl = getDataUrl();

      if (!dataUrl) {
        sizeChartDataPromise = Promise.reject(new Error("Missing size chart data URL."));
        return sizeChartDataPromise;
      }

      sizeChartDataPromise = fetch(dataUrl, { credentials: "same-origin" }).then((response) => {
        if (!response.ok) {
          throw new Error("Unable to load size chart data.");
        }

        return response.json();
      });
    }

    return sizeChartDataPromise;
  }

  function createMeasurementRows(measurements) {
    return Object.entries(measurements || {})
      .map(([label, value]) => `
        <div class="product-size-chart__row">
          <dt>${escapeHTML(label)}</dt>
          <dd>${escapeHTML(value)}</dd>
        </div>
      `)
      .join("");
  }

  function createGarmentSections(garments) {
    return Object.entries(garments || {})
      .map(([name, measurements]) => `
        <div class="product-size-chart__garment">
          <h4>${escapeHTML(name)}</h4>
          <dl class="product-size-chart__rows product-size-chart__rows--compact">
            ${createMeasurementRows(measurements)}
          </dl>
        </div>
      `)
      .join("");
  }

  function getOptionLabel(input) {
    if (!input || !input.id) return input?.value || "";

    const optionValueName = input.getAttribute("data-option-value-name");

    if (optionValueName) return optionValueName;

    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    return label ? label.textContent.trim() : input.value;
  }

  function cleanOptionText(value) {
    return String(value || "")
      .replace(/(Sold out|Unavailable|已售罄|不可用)/gi, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function findSizeFieldset(chart) {
    const productPanel = chart.closest(".drahance-product-page__panel, .drahance-product-page");
    const variantPicker = productPanel?.querySelector("variant-picker");

    if (!variantPicker) return null;

    return Array.from(variantPicker.querySelectorAll(".variant-picker__option")).find((fieldset) => {
      const legend = fieldset.querySelector("legend");
      return /size/i.test(legend?.textContent || "");
    });
  }

  function findVariantPicker(chart) {
    const productPanel = chart.closest(".drahance-product-page__panel, .drahance-product-page");
    return productPanel?.querySelector("variant-picker") || null;
  }

  function getSelectedSize(chart) {
    const sizeFieldset = findSizeFieldset(chart);
    const checkedInput = sizeFieldset?.querySelector('input[type="radio"]:checked');

    return getOptionLabel(checkedInput);
  }

  function findChartForForm(form) {
    if (!form?.id) return null;

    const variantPicker = document.querySelector(`variant-picker[form-id="${CSS.escape(form.id)}"]`);
    const productPanel = variantPicker?.closest(".drahance-product-page__panel, .drahance-product-page");

    return productPanel?.querySelector("[data-product-size-chart]") || null;
  }

  function optionValueByName(chart, optionName) {
    const expected = String(optionName || "").trim().toLowerCase();
    if (!expected) return "";

    const variantPicker = findVariantPicker(chart);
    if (!variantPicker) return "";

    const fieldsets = Array.from(variantPicker.querySelectorAll(".variant-picker__option, fieldset"));
    const fieldset = fieldsets.find((candidate) => {
      const legend = candidate.querySelector("legend");
      return cleanOptionText(legend?.textContent).replace(/[:：]$/, "").toLowerCase() === expected;
    });

    if (!fieldset) return "";

    const checkedInput = fieldset.querySelector('input[type="radio"]:checked, input[data-option-position]:checked');
    if (checkedInput) return cleanOptionText(getOptionLabel(checkedInput));

    const selectedText = fieldset.querySelector('.variant-picker__option-info span, button.select span[id$="selected-value"]');
    return cleanOptionText(selectedText?.textContent);
  }

  function configLines(config) {
    return String(config || "")
      .replace(/\r/g, "")
      .replace(/\s*(\[[^\]]+\])\s*/g, "\n$1\n")
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);
  }

  function parseSizeHeading(heading) {
    const match = String(heading || "").match(/^(size|尺码|尺碼|尺寸)\s*[:：]\s*(.+)$/i);
    return match ? match[2].trim() : "";
  }

  function parseMatchHeading(heading) {
    const match = String(heading || "").match(/^(match|matching rule|匹配|匹配规则|匹配規則)\s*[:：]\s*(.+)$/i);
    return match ? match[2].trim() : "";
  }

  function parseCustomChart(configText) {
    const parsed = { matchRule: "", sizes: {} };
    let currentSize = null;
    let currentSection = null;

    configLines(configText).forEach((line) => {
      const headingMatch = line.match(/^\[(.+)]$/);

      if (headingMatch) {
        const heading = headingMatch[1].trim();
        const matchRule = parseMatchHeading(heading);

        if (matchRule) {
          parsed.matchRule = matchRule;
          currentSection = null;
          return;
        }

        const sizeLabel = parseSizeHeading(heading);

        if (sizeLabel) {
          currentSize = { label: sizeLabel, body: {}, garments: {} };
          parsed.sizes[normalizeChartSize(sizeLabel)] = currentSize;
          currentSection = null;
          return;
        }

        if (!currentSize) return;

        currentSection = heading;
        if (!/^body size$/i.test(currentSection)) {
          currentSize.garments[currentSection] = currentSize.garments[currentSection] || {};
        }

        return;
      }

      if (!currentSize || !currentSection) return;

      const normalizedLine = line.replace("：", ":");
      const colonIndex = normalizedLine.indexOf(":");
      if (colonIndex <= 0) return;

      const label = normalizedLine.slice(0, colonIndex).trim();
      const value = normalizedLine.slice(colonIndex + 1).trim();
      if (!label || !value) return;

      if (/^body size$/i.test(currentSection)) {
        currentSize.body[label] = value;
      } else {
        currentSize.garments[currentSection][label] = value;
      }
    });

    return Object.keys(parsed.sizes).length ? parsed : null;
  }

  function getCustomChart(config) {
    if (!config.garmentMeasurements) return null;
    return parseCustomChart(config.garmentMeasurements);
  }

  function selectedCustomSize(chart, customChart, fallbackSize) {
    if (customChart?.matchRule) {
      let missingValue = false;
      const label = customChart.matchRule.replace(/\{\{\s*([^}]+?)\s*\}\}/g, (_match, optionName) => {
        const value = optionValueByName(chart, optionName);
        if (!value) missingValue = true;
        return value;
      });

      if (!missingValue) return label.replace(/\s+/g, " ").trim();
    }

    return fallbackSize;
  }

  function showFallback(chart) {
    const grid = chart.querySelector("[data-size-chart-grid]");
    const message = chart.querySelector("[data-size-chart-message]");

    if (grid) grid.hidden = true;
    if (message) {
      message.textContent = FALLBACK_MESSAGE;
      message.hidden = false;
    }
  }

  function renderCustomChart(chart, size, customChart) {
    const selectedSize = selectedCustomSize(chart, customChart, size);

    if (isCustomSize(selectedSize)) {
      chart.hidden = true;
      return true;
    }

    const sizeData = customChart?.sizes?.[normalizeChartSize(selectedSize)];
    if (!sizeData) return false;

    chart.hidden = false;

    const current = chart.querySelector("[data-size-chart-current]");
    const body = chart.querySelector("[data-size-chart-body]");
    const garments = chart.querySelector("[data-size-chart-garments]");
    const grid = chart.querySelector("[data-size-chart-grid]");
    const message = chart.querySelector("[data-size-chart-message]");
    const bodyCard = chart.querySelector("[data-size-chart-body-card]");
    const garmentCard = chart.querySelector("[data-size-chart-garment-card]");
    const hasBody = Object.keys(sizeData.body || {}).length > 0;
    const hasGarments = Object.keys(sizeData.garments || {}).length > 0;

    if (current) current.textContent = `SIZE ${sizeData.label || selectedSize || ""}`.trim();
    if (message) message.hidden = true;
    if (grid) grid.hidden = false;
    if (bodyCard) bodyCard.hidden = !hasBody;
    if (garmentCard) garmentCard.hidden = !hasGarments;
    if (body) body.innerHTML = createMeasurementRows(sizeData.body);
    if (garments) garments.innerHTML = createGarmentSections(sizeData.garments);

    return hasBody || hasGarments;
  }

  function renderChart(chart, size, allData) {
    if (isCustomSize(size)) {
      chart.hidden = true;
      return;
    }

    chart.hidden = false;

    const normalizedSize = normalizeSize(size);
    const config = getConfig();
    const customChart = getCustomChart(config);

    if (customChart && renderCustomChart(chart, size, customChart)) {
      return;
    }

    const sizeChartType = resolveSizeChartType(config);
    const gender = resolveGender(config, sizeChartType);
    const bodyData = allData?.body_size?.[gender]?.[normalizedSize];
    const garmentData = sizeChartType ? allData?.garment_measurements?.[sizeChartType]?.[normalizedSize] : null;
    const current = chart.querySelector("[data-size-chart-current]");
    const body = chart.querySelector("[data-size-chart-body]");
    const garments = chart.querySelector("[data-size-chart-garments]");
    const grid = chart.querySelector("[data-size-chart-grid]");
    const message = chart.querySelector("[data-size-chart-message]");
    const bodyCard = chart.querySelector("[data-size-chart-body-card]");
    const garmentCard = chart.querySelector("[data-size-chart-garment-card]");

    if (current) current.textContent = `SIZE ${normalizedSize || size || ""}`.trim();

    if (!bodyData || !garmentData) {
      showFallback(chart);
      return;
    }

    if (message) message.hidden = true;
    if (grid) grid.hidden = false;
    if (bodyCard) bodyCard.hidden = false;
    if (garmentCard) garmentCard.hidden = false;
    if (body) body.innerHTML = createMeasurementRows(bodyData);
    if (garments) garments.innerHTML = createGarmentSections(garmentData);
  }

  function setupChart(chart) {
    if (chart.dataset.sizeChartInitialized === "true") {
      return;
    }

    chart.dataset.sizeChartInitialized = "true";

    loadSizeChartData()
      .then((allData) => {
        const selectedSize = getSelectedSize(chart);

        if (selectedSize) {
          renderChart(chart, selectedSize, allData);
        } else {
          showFallback(chart);
        }

        const variantPicker = findVariantPicker(chart);
        const formId = variantPicker?.getAttribute("form-id");
        const form = formId ? document.getElementById(formId) : null;

        if (!form || form.dataset.sizeChartEventsBound === "true") return;

        form.dataset.sizeChartEventsBound = "true";

        const syncFromCurrentVariant = () => {
          window.requestAnimationFrame(() => {
            initCharts();

            const currentChart = findChartForForm(form) || chart;
            const currentSize = getSelectedSize(currentChart);

            if (currentSize) {
              renderChart(currentChart, currentSize, allData);
            }
          });
        };

        form.addEventListener("variant:change", syncFromCurrentVariant);
        form.addEventListener("product:rerender", syncFromCurrentVariant);
      })
      .catch(() => showFallback(chart));
  }

  function initCharts() {
    document.querySelectorAll("[data-product-size-chart]").forEach(setupChart);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCharts, { once: true });
  } else {
    initCharts();
  }

  document.addEventListener("change", (event) => {
    const target = event.target;

    if (!(target instanceof HTMLInputElement) || target.type !== "radio") return;

    const sizeFieldset = target.closest(".variant-picker__option, fieldset");
    const legend = sizeFieldset?.querySelector("legend");

    if (!/size/i.test(legend?.textContent || "")) return;

    const variantPicker = target.closest("variant-picker");
    const productPanel = variantPicker?.closest(".drahance-product-page__panel, .drahance-product-page");
    const chart = productPanel?.querySelector("[data-product-size-chart]");

    if (!chart) return;

    loadSizeChartData()
      .then((allData) => renderChart(chart, getOptionLabel(target), allData))
      .catch(() => showFallback(chart));
  });
})();
